import { supabase } from '../../lib/supabase';
import { toast } from 'react-hot-toast';
import type { CourseModule } from '../../types/course';

export async function updateCourseModules(courseId: string, modules: CourseModule[]) {
  try {
    // First delete existing modules (this will cascade delete lessons)
    const { error: deleteError } = await supabase
      .from('course_modules')
      .delete()
      .eq('course_id', courseId);

    if (deleteError) throw deleteError;

    // Insert new modules and their lessons
    for (const [moduleIndex, module] of modules.entries()) {
      // Insert module
      const { data: newModule, error: moduleError } = await supabase
        .from('course_modules')
        .insert({
          course_id: courseId,
          title: module.title,
          description: module.description,
          duration: module.duration,
          sequence_number: moduleIndex + 1
        })
        .select()
        .single();

      if (moduleError) throw moduleError;

      // Insert lessons for this module
      if (module.lessons?.length) {
        const lessonsToInsert = module.lessons.map((lesson, lessonIndex) => ({
          module_id: newModule.id,
          title: lesson.title,
          duration: lesson.duration,
          type: lesson.type,
          content: lesson.content || '',
          sequence_number: lessonIndex + 1,
          status: lesson.status || 'draft',
          version: lesson.version || 1
        }));

        const { error: lessonsError } = await supabase
          .from('course_lessons')
          .insert(lessonsToInsert);

        if (lessonsError) throw lessonsError;
      }
    }

    toast.success('Course modules updated successfully');
    return true;
  } catch (error) {
    console.error('Error updating course modules:', error);
    toast.error('Failed to update modules');
    throw error;
  }
}